/**
 *  @internal Keys that are used for the pivot maps
 */
export const PIVOTS_KEY_EVENTS_TICKETS = 'events-tickets';
export const PIVOTS_KEY_PRODUCTS_METADATA = 'products-metadata';
export const PIVOTS_KEY_PRODUCTS_TICKETS = 'products-tickets';
export const PIVOTS_KEY_PRODUCTS_EVENT_DATES = 'products-eventDates';
export const PIVOTS_KEY_SHOPS_COLLAPSES = 'shops-collapses';
export const PIVOTS_KEY_SHOPS_METADATA = 'shops-metadata';
export const PIVOTS_KEY_SHOPS_PRODUCTS = 'shops-products'; // Global products
export const PIVOTS_KEY_SHOPS_TICKETS = 'shops-tickets';
export const PIVOTS_KEY_SHOPS_PAYMENT_METHODS = 'shops-paymentmethods';
export const PIVOTS_KEY_TICKETS_GROUPS = 'tickets-groups';
export const PIVOTS_KEY_GROUPS_PRODUCTS = 'groups-products';
/**
 *  @internal Type of sorting of pivots.
 */
export var OrderType;
(function (OrderType) {
    OrderType["Incremental"] = "incremental";
    OrderType["LinkedList"] = "linkedlist";
    OrderType["SternBrocot"] = "sternbrocot";
})(OrderType || (OrderType = {}));
//# sourceMappingURL=types.js.map